import React from "react";
import { FiAward, FiCamera, FiUsers, FiCheckCircle } from "react-icons/fi";
import flagsImg from "../../images/flags.png";

const stats = [
  { icon: <FiAward />, number: "7+", label: "Years Experience" },
  { icon: <FiCamera />, number: "500K+", label: "Photos Edited" },
  { icon: <FiUsers />, number: "300+", label: "Happy Clients" },
  { icon: <FiCheckCircle />, number: "1500+", label: "Projects Delivered" },
];

const StatsBar = () => {
  return (
    <div className="stats-bar">
      <div className="stats-bar-inner">
        <div className="stats-items">
          {stats.map((stat) => (
            <div className="stat-item" key={stat.label}>
              <div className="stat-top">
                <span className="stat-icon">{stat.icon}</span>
                <span className="stat-number">{stat.number}</span>
              </div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="stats-divider" />

        <div className="stats-trusted">
          <div className="trusted-title">
            <FiCheckCircle />
            <span>Trusted by Photographers Worldwide</span>
          </div>
          <div className="trusted-flags">
            <img
              src={flagsImg}
              alt="Trusted by photographers in the US, UK, Canada, Australia, Germany, Netherlands, and India"
              className="trusted-flags-img"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsBar;
